import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function BrandVoice() {
  return <div className="min-h-screen bg-[#d9e2e8] p-2 md:p-4 font-sans selection:bg-accent selection:text-white" data-id="element-134">
      <div className="main-container max-w-[1600px] mx-auto bg-card rounded-[1.5rem] md:rounded-[2rem] border border-black/5 shadow-sm min-h-[calc(100vh-2rem)] flex flex-col" data-id="element-135">
        <Navigation activePath="/brandvoice" data-id="element-136" />

        <main className="flex-1 px-4 md:px-16 py-8 space-y-12 md:space-y-32" data-id="element-137">
          {/* Hero Section */}
          <section className="relative flex flex-col justify-between pt-4 md:pt-8 pb-8 md:pb-12" data-id="element-138">
            <div className="max-w-6xl" data-id="element-139">
              <h1 className="text-[clamp(2.5rem,8vw,8rem)] font-semibold leading-[0.95] md:leading-[0.9] tracking-[-0.04em] text-ink" data-id="element-140">
                Brand <br data-id="element-141" />
                Voice
                <span className="text-accent inline-block w-[0.15em] h-[0.15em] rounded-full ml-[0.05em] mb-[0.1em]" data-id="element-142" />
              </h1>
              <div className="mt-6 max-w-sm text-base md:text-lg leading-[1.6] md:leading-[1.7] text-ink/70 font-medium" data-id="element-143">
                Defining how Headway Tuition speaks, reassures, and guides
                parents and children.
              </div>
            </div>
          </section>

          {/* Messaging Section */}
          <section className="space-y-8 md:space-y-12" data-id="element-144">
            <div className="bg-white rounded-[1rem] md:rounded-[1.5rem] p-6 md:p-12 border border-black/5 space-y-10 md:space-y-16" data-id="element-145">
              <div className="space-y-6 md:space-y-8" data-id="element-146">
                <div className="flex items-center gap-3" data-id="element-147">
                  <div className="w-2 md:w-2.5 h-2 md:h-2.5 rounded-full bg-accent" data-id="element-148" />
                  <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-medium text-muted-foreground" data-id="element-149">
                    Core Narrative
                  </span>
                </div>

                <div className="space-y-4 md:space-y-6" data-id="element-150">
                  <p className="font-sans font-bold text-xl md:text-4xl text-ink max-w-4xl leading-tight tracking-tight" data-id="element-151">
                    warm, calm and honest.
                  </p>
                  <p className="text-sm md:text-lg leading-[1.6] md:leading-[1.7] text-ink/70 font-medium max-w-3xl" data-id="element-152">
                    All communication explains the 11+ journey from Year 3 to
                    Year 6 in clear, simple language and shows how children can
                    move from early potential to confident exam performance
                    without sacrificing their wellbeing.
                  </p>
                  <p className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-bold text-accent" data-id="element-153">
                    Use this voice in all marketing, social content, emails and
                    creative briefs.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 border-t border-border pt-10 md:pt-16" data-id="element-154">
                <div className="space-y-6 md:space-y-8" data-id="element-155">
                  <h3 className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-bold text-ink" data-id="element-156">
                    Core qualities
                  </h3>
                  <div className="space-y-6 md:space-y-8" data-id="element-157">
                    {[{
                    title: 'Warm and human',
                    desc: 'Everyday language, first person, no jargon; it should feel like a real teacher speaking, not an institution.'
                  }, {
                    title: 'Calm and steady',
                    desc: 'We lower the temperature; no scare tactics or manufactured urgency.'
                  }, {
                    title: 'Honest and direct',
                    desc: 'We tell the truth kindly about pressure, fit and limits; no miracle promises.'
                  }, {
                    title: 'Protective of confidence',
                    desc: "The child's long‑term wellbeing matters more than one exam result."
                  }, {
                    title: 'Collaborative',
                    desc: 'We always frame the 11+ as a shared journey between child, parent, school and tutor.'
                  }].map((quality, i) => <div key={i} className="space-y-1 md:space-y-2" data-id="element-158">
                        <h4 className="font-sans font-semibold text-lg md:text-xl text-ink" data-id="element-159">
                          {quality.title}
                        </h4>
                        <p className="text-xs md:text-base leading-[1.6] text-ink/70" data-id="element-160">
                          {quality.desc}
                        </p>
                      </div>)}
                  </div>
                </div>

                <div className="space-y-10 md:space-y-12" data-id="element-161">
                  <div className="space-y-6 md:space-y-8" data-id="element-162">
                    <h3 className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-bold text-ink" data-id="element-163">
                      When writing, aim to:
                    </h3>
                    <ul className="space-y-4" data-id="element-164">
                      {['Explain the 11+ in simple, concrete terms (stages, skills, roles, checklists).', 'Reassure first, then give a clear, realistic next step a parent or child can take.', 'Emphasise healthy preparation: short, regular sessions, understanding before speed, and space for mistakes.', "Treat parents' worries with respect and name real pressures (community, comparison, results)."].map((item, i) => <li key={i} className="flex gap-3 md:gap-4 items-start text-xs md:text-base leading-[1.6] text-ink/70" data-id="element-165">
                          <div className="mt-1.5 md:mt-2 w-1.5 h-1.5 rounded-full bg-accent shrink-0" data-id="element-166" />
                          {item}
                        </li>)}
                    </ul>
                  </div>

                  <div className="space-y-6 md:space-y-8 pt-8 border-t border-border" data-id="element-167">
                    <h3 className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-bold text-ink" data-id="element-168">
                      Avoid:
                    </h3>
                    <ul className="space-y-4" data-id="element-169">
                      {['Using fear, guilt or "last chance" language to push tuition.', 'Speaking as if grammar school is the only success path.', 'Suggesting the tutor is a magician or that parents can outsource all responsibility.', 'Boasting about results without context; focus instead on growth, resilience and fit.'].map((item, i) => <li key={i} className="flex gap-3 md:gap-4 items-start text-xs md:text-base leading-[1.6] text-ink/70" data-id="element-170">
                          <div className="mt-1.5 md:mt-2 w-1.5 h-1.5 rounded-full bg-border shrink-0" data-id="element-171" />
                          {item}
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Restored Messaging Statements */}
          <section className="space-y-8 md:space-y-12" data-id="element-172">
            <div className="space-y-6 md:space-y-8" data-id="element-173">
              <div className="flex items-center gap-3" data-id="element-174">
                <div className="w-2 md:w-2.5 h-2 md:h-2.5 rounded-full bg-accent" data-id="element-175" />
                <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-medium text-muted-foreground" data-id="element-176">
                  Key Messaging
                </span>
              </div>
              <h2 className="font-sans font-semibold text-2xl md:text-5xl leading-tight tracking-tight text-ink" data-id="element-177">
                Core Statements
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-178">
              {/* Statement 01 */}
              <div className="bg-card rounded-[1rem] md:rounded-[2rem] p-8 md:p-16 border border-black/5 flex flex-col gap-4 md:gap-8" data-id="element-179">
                <span className="font-sans font-bold text-6xl md:text-[10rem] leading-[0.8] tracking-[-0.04em] text-ink" data-id="element-180">
                  01
                </span>
                <div className="flex gap-4 md:gap-6 items-stretch" data-id="element-181">
                  <div className="w-1 md:w-1.5 bg-accent rounded-full shrink-0" data-id="element-182" />
                  <p className="font-sans font-semibold text-lg md:text-4xl leading-tight tracking-tight text-ink pt-1 md:pt-2" data-id="element-183">
                    The pathway for year 3 to year 6 for 11+ exams.
                  </p>
                </div>
              </div>

              {/* Statement 02 */}
              <div className="bg-cyan rounded-[1rem] md:rounded-[2rem] p-8 md:p-16 border border-black/5 flex flex-col gap-4 md:gap-8" data-id="element-184">
                <span className="font-sans font-bold text-6xl md:text-[10rem] leading-[0.8] tracking-[-0.04em] text-white" data-id="element-185">
                  02
                </span>
                <div className="flex gap-4 md:gap-6 items-stretch" data-id="element-186">
                  <div className="w-1 md:w-1.5 bg-white rounded-full shrink-0" data-id="element-187" />
                  <p className="font-sans font-semibold text-lg md:text-4xl leading-tight tracking-tight text-white pt-1 md:pt-2" data-id="element-188">
                    Guiding students from early potential to confident exam
                    performance.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer data-id="element-189" />
      </div>
    </div>;
}